import ObjectHandleService from "@/services/common/ObjectHandleService";

export default {
	/**
	 * Filtra as turbinas de acordo com a string de pesquisa.
	 * @returns turbinas filtradas de acorod com a string de pesquisa.
	 */
	filteredTurbines: (state, getters) =>
	{
		const turbines = getters["WindAssetModule/getTurbines"] || [];

		const rawSelection = state.SelectedReferenceTurbine;
		const selectedId = ObjectHandleService.IsObject(rawSelection) ? rawSelection.id : rawSelection;

		const indexToRemove = turbines.findIndex(t => t.id === selectedId);

		let availableTurbines;

		if (indexToRemove === -1)
		{
			availableTurbines = turbines;
		}
		else
		{
			availableTurbines = turbines.slice(0, indexToRemove).concat(turbines.slice(indexToRemove + 1));
		}

		const search = (state.TurbineSearch || "").trim().toLowerCase();

		if (!search) return availableTurbines;

		return availableTurbines.filter(t => t.name.toLowerCase().includes(search));
	},
};